if (!customElements.get('cc-party-decal-addon')) {
  customElements.define('cc-party-decal-addon', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', () => this.sync(), { signal: this.controller.signal });
      this.addEventListener('input', () => this.updateLink(), { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-decal-addon-link]')) this.updateLink();
      }, { signal: this.controller.signal });
      queueMicrotask(() => this.sync());
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    sync() {
      const choice = this.querySelector('[data-decal-addon-choice]');
      if (!choice) return;
      const enabled = Boolean(choice.value);
      this.querySelectorAll('[data-decal-addon-field]').forEach(field => {
        field.disabled = !enabled;
      });
      this.querySelector('[data-decal-addon-quantity]').required = enabled;
      this.updateLink();
    }
    updateLink() {
      const choice = this.querySelector('[data-decal-addon-choice]');
      const link = this.querySelector('[data-decal-addon-link]');
      if (!choice || !link) return;
      const url = new URL('/pages/contact', window.location.origin);
      url.searchParams.set('view', 'decal-quote');
      url.searchParams.set('package', this.dataset.package);
      const key = choice.selectedOptions[0]?.dataset.decal;
      if (key) url.searchParams.set('decal', key);
      const count = this.querySelector('[data-decal-addon-quantity]');
      if (choice.value && count.value && count.checkValidity()) {
        url.searchParams.set('decal_quantity', count.value);
      }
      link.href = url.pathname + url.search;
    }
  });
}
